export default "__VITE_ASSET__c9d54bcc__"